// Service list shared by the homepage Services section, area pages and structured data.
// Titles must match the quote form's <option> values and SERVICES in functions/src/quote.ts.
export const SERVICES = [
  {
    icon: 'ri-building-2-line',
    title: 'Office Space Cleaning',
    description: 'Keep your workspace pristine and professional. Perfect for small offices, co-working spaces, and corporate environments.',
    image: '/images/service-office-002.webp',
    alt: 'Tidy professional office with clean desks and bright natural light'
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'After-Hours Cleaning',
    description: "We work around your business hours so there's zero disruption. Arrive each morning to a spotless, refreshed workspace ready for the day.",
    image: '/images/service-afterhours-001.webp',
    alt: 'Cleaner sanitizing desks in an empty office after business hours'
  },
  {
    icon: 'ri-repeat-line',
    title: 'Recurring Service',
    description: 'Daily, weekly, bi-weekly, or monthly plans for offices of all sizes. Consistent quality, predictable scheduling, one less thing on your plate.',
    image: '/images/service-recurring-002.webp',
    alt: 'Cleaning team keeping a modern office on a recurring schedule'
  },
  {
    icon: 'ri-sparkling-2-line',
    title: 'Deep Cleaning',
    description: 'Thorough top-to-bottom cleaning for offices and commercial spaces. Perfect for seasonal refreshes, move-in/move-out, or pre-inspection prep.',
    image: '/images/service-deep-002.webp',
    alt: 'Freshly deep-cleaned commercial restroom with spotless tile and fixtures'
  },
  {
    icon: 'ri-team-line',
    title: 'Multi-Location Service',
    description: "Managing multiple offices? We'll handle them all with consistent quality across every location. One point of contact, one invoice, zero hassle.",
    image: '/images/service-multi-001.webp',
    alt: 'Cleaning crew organizing supplies in an office hallway'
  },
  {
    icon: 'ri-magic-line',
    title: 'Specialty Cleaning',
    description: 'Carpet steaming, window washing, upholstery care, and post-renovation cleanup. The extras that keep your workspace looking brand new.',
    image: '/images/service-specialty-001.webp',
    alt: 'Carpet steam cleaning machine working on commercial office carpet'
  }
];
